<template>
  <v-layout align-start>
    <v-flex>
      <v-data-table :headers="headers" :items="tipooperaciones" :search="search" class="elevation-1">
        <template v-slot:top>
          <v-toolbar color="white">
            <v-toolbar-title><v-icon>directions_car</v-icon></v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line
              hide-details></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="800px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on" fab small>
                  <span class="material-icons"> add </span>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="12" class="py-0">
                        <v-alert type="success" class="subtitle-2 text-center" color="primary">Datos Generales del
                          Vehiculo</v-alert>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-text-field v-model="vehiculonombre" label="Nombre del Vehiculo " outlined></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-autocomplete v-model="clienteid" label="Buscar Cliente" :items="clientestodosselect"
                          item-text="clientenombre" item-value="clienteigas" outlined></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="4" md="4" class="py-0">
                        <v-text-field v-model="vehiculoplacas" label="Placas del Vehiculo " outlined></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="4" class="py-0">
                        <v-text-field v-model="vehiculocapacidad" label="Capacidad del Vehiculo " type="number"
                          outlined></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4" md="4" class="py-0">
                        <v-text-field v-model="vehiculocolor" label="Color del Vehiculo " outlined></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-text-field v-model="vehiculomodelo" label="Modelo del Vehiculo " outlined></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" class="py-0">
                        <v-select v-model="combustibleid" :items="combustibleselect" label="Tipo de Combustible"
                          outlined></v-select>
                      </v-col>

                      <v-col cols="12" md="12" align="center" justify="center">
                        <label>
                          Carga El Documento
                          <input type="file" id="file" ref="file" accept="image/jpeg, image/png, .pdf"
                            v-on:change="handleFileUpload()" />
                        </label>
                      </v-col>

                      <v-card max-width="1200" class="mx-auto">
                        <v-list-item>
                          <v-list-item-avatar color="grey"></v-list-item-avatar>
                          <v-list-item-content align="center" justify="center">
                            <v-list-item-title class="headline">Visualizando el Vehiculo</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>

                        <v-col cols="12" md="12" align="center" justify="center" v-if="imagenopdf == 1">
                          <v-img :src="imagePreview" aspect-ratio="1.75" max-height="400" contain></v-img>
                        </v-col>

                        <v-card-text align="center" justify="center">Antes de Guardar el Documento Verifique que sea el
                          Correcto</v-card-text>
                      </v-card>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                  <v-btn color="blue darken-1" text @click="guardar">Guardar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogfoto" max-width="800px">
              <v-card>
                <v-card-title>
                  <span class="headline">Editar Foto del Vehiculo</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="12" class="py-0">
                        <v-alert type="success" class="subtitle-2 text-center" color="primary"> Editar Foto del
                          Vehiculo</v-alert>
                      </v-col>

                      <v-col cols="12" md="12" align="center" justify="center">
                        <label>
                          Carga El Documento
                          <input type="file" id="file" ref="file" accept="image/jpeg, image/png, .pdf"
                            v-on:change="handleFileUpload()" />
                        </label>
                      </v-col>

                      <v-card max-width="1200" class="mx-auto">
                        <v-list-item>
                          <v-list-item-avatar color="grey"></v-list-item-avatar>
                          <v-list-item-content align="center" justify="center">
                            <v-list-item-title class="headline">Visualizando el Vehiculo</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>

                        <v-col cols="12" md="12" align="center" justify="center" v-if="imagenopdf == 1">
                          <v-img :src="imagePreview" aspect-ratio="1.75" max-height="400" contain
                            class="grey darken-4"></v-img>
                        </v-col>



                        <v-card-text align="center" justify="center">Antes de Guardar el Documento Verifique que sea el
                          Correcto</v-card-text>
                      </v-card>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                  <v-btn color="blue darken-1" text @click="guardarfoto">Guardar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>


          </v-toolbar>
        </template>

        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon dense class="mr-2" @click="editItem(item)" v-on="on">edit</v-icon>
            </template>
            <span>Editar Datos Vehiculo</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon dense class="mr-2" @click="editimg(item)" v-on="on">image</v-icon>
            </template>
            <span>Editar Imagen</span>
          </v-tooltip>

          <template v-if="item.vehiculoestatus == 1">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon dense class="mr-2" @click="desactivar(item)" v-on="on">block</v-icon>
              </template>
              <span>Desactivar Vehiculo</span>
            </v-tooltip>
          </template>
          <template v-if="item.vehiculoestatus == 2">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon dense class="mr-2" @click="activar(item)" v-on="on">check</v-icon>
              </template>
              <span>Activar Vehiculo</span>
            </v-tooltip>
          </template>
          <template>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon dense class="mr-2" @click="eliminar(item)" v-on="on">delete</v-icon>
              </template>
              <span>Eliminar Vehiculo</span>
            </v-tooltip>
          </template>
          <template>
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon dense class="mr-2" @click="imprimir(item)" v-on="on">print</v-icon>
              </template>
              <span>Imprimir QR</span>
            </v-tooltip>
          </template>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="listar">Reset</v-btn>
        </template>

        <template v-slot:item.vehiculoestatus="{ item }">
          <v-chip :color="getColor(item.vehiculoestatus)" dark v-if="item.vehiculoestatus == 1">ACTIVO</v-chip>
          <v-chip :color="getColor(item.vehiculoestatus)" dark v-if="item.vehiculoestatus == 2">SUSPENDIDO</v-chip>
        </template>

        <template v-slot:item.parentescofecha="{ item }">
          <p>{{ getHumanDate(item.parentescofecha) }}</p>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      // Variable categoria
      dialog: false,
      dialogfoto: false,
      headers: [
        { text: "Accion", value: "action", sortable: false },
        { text: "Nombre", value: "vehiculonombre" },
        { text: "Modelo", value: "vehiculomodelo" },
        { text: "Placa", value: "vehiculoplacas" },
        { text: "Cliente", value: "clientenombre" },
        { text: "Estatus", value: "vehiculoestatus", sortable: false },
      ],

      tipooperaciones: [],
      search: "",
      editedIndex: -1,
      //Declaracion de varaibles
      vehiculoid: "",
      vehiculonombre: "",
      clienteid: "",
      vehiculoplacas: "",
      vehiculocapacidad: "",
      vehiculocolor: "",
      vehiculomodelo: "",
      combustibleid: "",
      // Declara variables de Validacion
      valida: 0,
      validamensaje: [],
      // Declara Varaiables para activar o desactivar categorias
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      imagePreview: null,
      imagenopdf: 0,
      file: "",

      //
      clienteigas: "",
      listarclienteid: 0,
      listarclienteselect: [],
      clientestodosselect: [],
      combustibleselect: [],
      combustibleid: "",
      guardareditar: 1,
      url: process.env.VUE_APP_CLOUDINARY_URL_ROOT + "api/vehiculos/",
    
    };
  },
  // Crea una nueva categoria si es -1
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Nuevo Vehiculo"
        : "Actualizando Vehiculo";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.listar();
    this.listarclientes();
    this.clientetodos();
    this.selectgasolinatipo();
  },

  //
  methods: {
    getHumanDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    // metodo listar
    listar() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado e catalogos
      axios
        .get("api/vehiculos/listarvehiculos", configuracion)
        .then(function (response) {
          //console.log(response.data.vehiculo);
          me.tipooperaciones = response.data.vehiculo;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    listarclientes() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/movimientos/listarcredito/3/" + me.turnoid + "/" + me.date,
          configuracion
        )
        .then(function (response) {
          listaArray = response.data.clientes;
          listaArray.map(function (x) {
            me.listarclienteselect.push({
              text: x.clientenombre,
              value: x.clienteigas,
            });
          });
          me.listarclienteselect.push({
            text: "TODOS",
            value: 1,
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    clientetodos() {
      let me = this;
      var listaArray = [];
      var nombre = "";
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/clientes/listar", configuracion)
        .then(function (response) {
          me.clientestodosselect = response.data.cliente;
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("El Cliente No Existe");
            me.clienteigas = "";
          }
        });
    },

    selectgasolinatipo() {
      let me = this;
      var listaArray = [];
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/combustibles/listarcombustibles", configuracion)
        .then(function (response) {
          listaArray = response.data.combustible;
          listaArray.map(function (x) {
            me.combustibleselect.push({
              text: x.combustiblenombre,
              value: x.combustibleid,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    imprimir(item){

      window.open(
        this.url + "pdfvehiculo/"+item.vehiculoid
      );

    },

    handleFileUpload() {
      /*
          Set the local file variable to what the user has selected.
        */
      this.file = this.$refs.file.files[0];

      /*
          Initialize a File Reader object
        */
      let reader = new FileReader();

      /*
          Add an event listener to the reader that when the file
          has been loaded, we flag the show preview as true and set the
          image to be what was read from the reader.
        */
      reader.addEventListener(
        "load",
        function () {
          if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
            this.imagenopdf = 1;
            this.showPreview = true;
            this.imagePreview = reader.result;
          }

          if (/\.(pdf)$/i.test(this.file.name)) {
            this.showPreview = true;
            this.pdfPreview = reader.result;
          }
        }.bind(this),
        false
      );

      /*
          Check to see if the file is not empty.
        */
      if (this.file) {
        /*
            Ensure the file is an image file.
          */
        if (/\.(jpe?g|png|gif)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
        if (/\.(pdf)$/i.test(this.file.name)) {
          reader.readAsDataURL(this.file);
        }
      }
    },

    eliminar(item) {
      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };

      // Actualiza

      me.$swal({
        icon: "warning",
        title: "Estas Seguro de Eliminar",
        text:
          "El Flete: " + item.fleteid + " Numero de Factura: " + item.facturaid,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
      }).then((result) => {
        if (result.value) {
          axios
            .put("api/vehiculos/eliminar/" + item.vehiculoid, {}, configuracion)
            .then(function (response) {
              me.botonver = 1;
              me.limpiar();
              me.listar();
              me.$swal("Eliminado", "Se a Eliminado con Exito", "success");
              me.close();
            })
            .catch(function (error) {
              if (error.status === 401) {
                me.$swal("La Sesión a Expirado");
                me.$store.dispatch("salir");
              }
              if (error.name == "Error") {
                me.limpiar();
                me.listar();
                me.close();
                me.$swal("No se a Eliminado Checar");
              }
            });
        }
      });
    },

    // Color
    getColor(socioestatus) {
      if (socioestatus == 1) return "#3F8103";
      if (socioestatus == 2) return "red";
    },

    // Actualiza la categotia
    editItem(item) {
      this.vehiculoid = item.vehiculoid;
      this.vehiculonombre = item.vehiculonombre;
      this.vehiculoduenio = item.vehiculoduenio;
      this.vehiculoplacas = item.vehiculoplacas;
      this.vehiculocapacidad = item.vehiculocapacidad;
      this.vehiculoplacas = item.vehiculoplacas;
      this.vehiculocolor = item.vehiculocolor;
      this.vehiculomodelo = item.vehiculomodelo;
      this.combustibleid = item.combustibleid;
      this.clienteid = item.clienteigas;
      this.editedIndex = 1;
      this.guardareditar = 2;
      this.verfoto(item);
      this.dialog = true;
    },

    verfoto(item) {
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      // Api Guardar
      axios
        .get("api/vehiculos/verfoto/" + item.vehiculoimg, configuracion)
        .then(function (response) {
          me.imagenopdf = 1;
          me.imagePreview = response.data.image;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    editimg(item) {
      this.vehiculoid = item.vehiculoid;
      this.dialogfoto = true;
      this.verfoto(item);
    },

    close() {
      this.dialog = false;
      this.dialogfoto = false;
      this.limpiar();
    },

    limpiar() {
      this.vehiculoid = "";
      this.vehiculonombre = "";
      this.clienteid = "";
      this.vehiculoplacas = "";
      this.vehiculocapacidad = "";
      this.vehiculocolor = "";
      this.vehiculomodelo = "";
      this.combustibleid = "";
      this.file = "";
      this.dialog = false;
      this.dialogfoto = false;
      this.imagePreview = null;
      this.imagenopdf = 0;
      this.guardareditar = 1;
    },

    guardar() {

      if (this.vehiculonombre == "") {
        this.$swal("No se a Especificado el Nombre del Vehiculo");
        return;
      }

      if (this.vehiculonombre == "") {
        this.$swal("No se a Especificado el Cliente");
        return;
      }

      if (this.vehiculoplacas == "") {
        this.$swal("No se a Especificado la Placa");
        return;
      }

      if (this.vehiculocapacidad == "") {
        this.$swal("No se a Especificado la Capacidad");
        return;
      }

      if (this.vehiculocolor == "") {
        this.$swal("No se a Especificado el Color");
        return;
      }

      if (this.vehiculomodelo == "") {
        this.$swal("No se a Especificado el Modelo");
        return;
      }

      if (this.combustibleid == "") {
        this.$swal("No se a Especificado el Tipo de Combustible");
        return;
      }

      if (this.file == "" && this.guardareditar == 1) {
        this.$swal("No se a Especificado la Imagen del Vehiculo");
        return;
      }


      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;

      let formData = new FormData();

      formData.append("vehiculonombre", me.vehiculonombre);
      formData.append("clienteid", me.clienteid);
      formData.append("vehiculoplacas", me.vehiculoplacas);
      formData.append("vehiculocapacidad", me.vehiculocapacidad);
      formData.append("vehiculocolor", me.vehiculocolor);
      formData.append("vehiculomodelo", me.vehiculomodelo);
      formData.append("combustibleid", me.combustibleid);
      formData.append("usuarioid", me.$store.state.usuario.usuarioid);
      formData.append("file0", me.file);

      if (me.guardareditar == 1) {
        axios
          .post("api/vehiculos/crear", formData, configuracion)
          .then(function (response) {
            me.limpiar();
            me.listar();
            me.$swal("Vehiculo Guadado con Exito");
          })
          .catch(function (error) {
            console.log(error);
            if (error.response.data.code == 400) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
          });
      }

      if (me.guardareditar == 2) {
        axios
          .put("api/vehiculos/actualizar/" + me.vehiculoid, {
            vehiculonombre: me.vehiculonombre,
            clienteid: me.clienteid,
            vehiculoplacas: me.vehiculoplacas,
            vehiculocapacidad: me.vehiculocapacidad,
            vehiculocolor: me.vehiculocolor,
            vehiculomodelo: me.vehiculomodelo,
            combustibleid: me.combustibleid,
            usuarioid: me.$store.state.usuario.usuarioid

          }, configuracion)
          .then(function (response) {
            me.limpiar();
            me.listar();
            me.$swal("Vehiculo Guadado con Exito");
          })
          .catch(function (error) {
            console.log(error);
            if (error.response.data.code == 400) {
              me.$swal("La Sesión a Expirado");
              me.$store.dispatch("salir");
            }
          });
      }


    },

    guardarfoto() {


      if (this.file == "") {
        this.$swal("No se a Especificado la Imagen del Vehiculo");
        return;
      }


      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;

      let formData = new FormData();


      formData.append("vehiculoid", me.vehiculoid);
      formData.append("file0", me.file);

      axios
        .post("api/vehiculos/actualizarfoto", formData, configuracion)
        .then(function (response) {
          me.limpiar();
          me.listar();
          me.$swal("Vehiculo Actualizado con Exito");
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });




    },

    validar() {
      this.valida = 0;
      this.validamensaje = [];

      if (!this.vehiculonombre) {
        this.validamensaje.push("Nombre Vacio");
      }
      if (!this.vehiculoduenio) {
        this.validamensaje.push("EL Dueño Vacio");
      }
      if (!this.vehiculoplacas) {
        this.validamensaje.push("Placa Vacia");
      }
      if (!this.vehiculocapacidad) {
        this.validamensaje.push("Capacidad Vacia");
      }

      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },

    ActivarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.adNombre = item.vehiculonombre;
      this.vehiculoid = item.vehiculoid;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },

    activarDesactivarCerrar() {
      this.adModal = 0;
    },

    activar(item) {
      var qs = require("qs");
      var data = qs.stringify({
        json: '{"vehiculoestatus":"1"}',
      });

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put(
          "api/vehiculos/activarvehiculos/" + item.vehiculoid,
          data,
          configuracion
        )
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    desactivar(item) {
      var qs = require("qs");
      var data = qs.stringify({
        json: '{"vehiculoestatus":"2"}',
      });

      let me = this;
      let header = { Authorization: this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put(
          "api/vehiculos/activarvehiculos/" + item.vehiculoid,
          data,
          configuracion
        )
        .then(function (response) {
          me.adModal = 0;
          me.adAccion = 0;
          me.adNombre = "";
          me.adId = "";
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.code == 400) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },
    
  },
};
</script>
